import type { Prompt } from "@1js/pl-types";
import React from "react";
import { useFlightContext } from "../../hooks/useFlightContext";
import type { HandlePromptsTabSelected } from "./AllPrompts.web.data";
import { useWorkgroups } from "./useWorkgroups.hook";

export type UseBookmarkPromptsProps = {
  handlePromptsTabSelected: HandlePromptsTabSelected;
  onBookmarkToggled?: () => void;
  setDialogOpen: (isOpen: boolean) => void;
  onDelete?: (prompt: Prompt) => void;
};

export const useBookmarkPrompts = ({
  handlePromptsTabSelected,
  onBookmarkToggled,
  setDialogOpen,
  onDelete,
}: UseBookmarkPromptsProps) => {
  useWorkgroups({ handlePromptsTabSelected });

  const { isFlightActive } = useFlightContext();

  const handleOnBookmarkToggled = React.useCallback(() => {
    if (onBookmarkToggled) {
      onBookmarkToggled();
    }
  }, [onBookmarkToggled]);

  const handleOnDelete = React.useCallback(
    (prompt: Prompt) => {
      setDialogOpen(false);
      onDelete && onDelete(prompt);
    },
    [onDelete, setDialogOpen]
  );

  return {
    isFlightActive,
    handleOnBookmarkToggled,
    handleOnDelete,
  };
};
